import { request } from '@/shared/api/request'

export const getOppvLast = () => {
	return request({ url: 'contract/oopv/getLast', method: 'GET' })
}
